export default __webpack_public_path__ + "static/media/PAFI_Ringkasan Risalah RUPS Juni 2023.0e14d25e.pdf";